export default __webpack_public_path__ + "static/media/_DSC0159.68921087.JPG";